module.exports = __webpack_public_path__ + "static/img/buy2.d5ebf55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buy2.png
// module id = ou0R
// module chunks = 1